import React from 'react'
import BackToUp from '@uiw/react-back-to-top';
import OrganicFruitsTenders from '../components/Desktop2/Organic Fruits Tenders/OrganicFruitsTenders'
import Additionalinformation from '../components/Desktop2/Additional information/Additionalinformation'
import RelatedProducts from '../components/Desktop2/Related Products/RelatedProducts';
const Desktop2 = () => {
  return (
    <>
      <OrganicFruitsTenders/>
      <Additionalinformation/>
      <RelatedProducts/>
     <div className="container">
        <BackToUp><i class="fa-solid fa-arrow-up"></i></BackToUp>
      </div>
    </>
  )
}

export default Desktop2